// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"f0c0a992","133":"58e46fa3","579":"555ec8ca","587":"16575616","787":"a19b4892","805":"5c090818","806":"af63dc6e"}[chunkId] + ".chunk.js";
};